// Placeholder UI (to be replaced with the real recipe card grid)
import { RecipeSummaryCard } from 'services/recipes/types';

const RecipeList = ({ recipes }: { recipes: RecipeSummaryCard[] }) => {
  return (
    <div>
      <div style={{ textAlign: 'center' }}>
        <h2>Recipe Card Grid</h2>
        <p style={{ marginTop: 8 }}>Total recipes = {recipes.length}</p>
      </div>
    </div>
  );
};

export default RecipeList;
